<template lang="html">
  <li class="navigation__item" :key="item.id">
    <component :is="type" class="navigation__link" :href="type === 'a' && item.url" @click="onClick">
      <span class="navigation__thumb">
        <img width="36" height="24" :src="item.thumbnail" :alt="item.title" />
      </span>
      <span>
        <span class="navigation__link-name">
          {{ item.title }}
        </span>
        <i v-if="item.shortDescription">{{ item.shortDescription }}</i>
      </span>
      <svg class="bi" width="16" height="16" fill="currentColor">
        <use href="../../static/bi-sprite.svg#arrow-right" />
      </svg>
    </component>
  </li>
</template>

<script>
import Vue from "vue";

export default Vue.extend({
  name: "NavigationItem",
  props: ["item", "type"],
  methods: {
    onClick() {
      this.type === "button" && this.$emit("click", this.item.id);
    }
  }
});
</script>
